import React from 'react';
import PropTypes from 'prop-types';

import { AuthFilter } from './AuthFilters';
import StandardLayout from '../StandardLayout';
import ConfirmEmail from './ConfirmEmailController';

export default class extends React.Component {
    
    static propTypes = {
        onSuccess: PropTypes.func.isRequired,
        onMismatch: PropTypes.func.isRequired,
    };
    
    render() {
        return (
            <AuthFilter onMismatch={this.props.onMismatch}>
                <StandardLayout>
                    <ConfirmEmail onSuccess={this.props.onSuccess}/>
                </StandardLayout>
            </AuthFilter>
        );
    }
}